import { Asterisk } from "lucide-react";

const items = [
  "Albany's Premier Rideshare",
  "Riders Big Savings",
  "Drivers Huge Earnings",
  "Safe & Verified",
  "Capital Region Proud",
  "Launching Soon",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      className="relative border-y border-white/10 bg-[#0a0a0a] py-6 overflow-hidden"
      data-testid="marquee-section"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display font-medium uppercase tracking-[0.25em] text-sm md:text-base text-zinc-400">
              {item}
            </span>
            <Asterisk className="w-5 h-5 text-brand-yellow shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
